<template>
  <button 
    class="cursor-pointer w-24 h-24 flex items-center justify-center rounded-full bg-black/50"
  >
    <FontAwesomeIcon 
      icon="play" 
      class="relative left-0.5 z-20 size-8!" 
      :class="{
        'text-primary-color': !getPrimaryColor, 
        [`text-[${getPrimaryColor}]`]: getPrimaryColor
      }"
    />
  </button>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'PlayButton',
    computed: {
      ...mapGetters('tour', ['getPrimaryColor']),
    },
  };
</script>
